import { webApiBuildUrl } from '@api/utils'
import { CatalogGoodBase, ICatalogGoodBase } from '@entities/goods/contract'
import { ErrorResponse, fetchApi } from 'src/shared/lib/response-worker/model'
import { IShipment } from 'src/shared/contract/shipment'
import { Array, Failure } from 'runtypes'

export const getSuggestionsSearchUrl = (term: string): string =>
    webApiBuildUrl(`api/catalog/goods/searchSuggestions?searchText=${term}`)

export const getSuggestionsUrl = (suggestionId: string | number): string =>
    webApiBuildUrl(`api/catalog/goods/suggestions?suggestionID=${suggestionId}`)

export async function getSuggestionById({
    suggestionId,
    shipment
}: {
    suggestionId: string | number
    shipment: IShipment
}): Promise<ICatalogGoodBase[]> {
    const response = await fetchApi.post<ICatalogGoodBase[]>(getSuggestionsUrl(suggestionId), shipment)
    const validated = Array(CatalogGoodBase).validate(response.data)
    if (!validated.success) {
        console.error(validated)
    }
    if (!(response.data as ErrorResponse).IsError) {
        return response.data as ICatalogGoodBase[]
    } else {
        throw new Error(JSON.stringify((validated as Failure).details))
    }
    return response.data as ICatalogGoodBase[]
}
